import { render, staticRenderFns } from "./TarimaTicketComponent.vue?vue&type=template&id=38cab25d&"
import script from "./TarimaTicketComponent.vue?vue&type=script&lang=js&"
export * from "./TarimaTicketComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports